/**
 * Which pills the patient list shows, and which one is open. With the Intake hub
 * on, the three stage pills give way to one Intake pill.
 */

import { FEATURE_FLAGS, PATIENT_PAGE_FILTER_OPTIONS, PatientPageFilterOption } from '@bariendo/lib/constants';
import { FilterOption } from '../types';
import type { IntakeTab } from '../intake/IntakeHub';

const INTAKE_TAB_BY_LEGACY_FILTER: Partial<Record<PatientPageFilterOption, IntakeTab>> = {
  [PATIENT_PAGE_FILTER_OPTIONS.ALL_INQUIRY]: 'inquiry',
  [PATIENT_PAGE_FILTER_OPTIONS.ALL_PRE_CONSULTATION]: 'pre-consultation',
  [PATIENT_PAGE_FILTER_OPTIONS.ALL_POST_CONSULTATION]: 'post-consultation',
};

/** The Intake sub-tab an old stage-pill value now lives under. */
export function intakeTabForFilter(filter: PatientPageFilterOption): IntakeTab | undefined {
  return INTAKE_TAB_BY_LEGACY_FILTER[filter];
}

interface FilterGates {
  isPhysicianOnly: boolean;
  isAllFiltersEnabled: boolean;
  isSignupsTrackerEnabled: boolean;
  isIntakeHubEnabled: boolean;
  /** The flag and `canViewCoverageHub` (BAR-3093). */
  isCoverageHubEnabled: boolean;
}

export function visibleFilterOptions(options: FilterOption[], gates: FilterGates): FilterOption[] {
  return options.filter((option) => {
    if (option.physicianRestricted && gates.isPhysicianOnly) {
      return false;
    }
    if (option.replacedByIntakeHub && gates.isIntakeHubEnabled) {
      return false;
    }
    if (option.featureFlag === FEATURE_FLAGS.ENABLE_INTAKE_HUB) {
      return gates.isIntakeHubEnabled;
    }
    if (option.featureFlag === FEATURE_FLAGS.ENABLE_COVERAGE_HUB) {
      return gates.isCoverageHubEnabled;
    }
    if (option.featureFlag) {
      return option.featureFlag === FEATURE_FLAGS.ENABLE_SIGNUPS_TRACKER ? gates.isSignupsTrackerEnabled : false;
    }
    if (option.featureFlagCheck) {
      return gates.isAllFiltersEnabled;
    }
    return true;
  });
}

/** An old stage pill opens the hub; a stored hub pill falls back to My patients when that hub is off. */
export function resolveListFilter(
  filter: PatientPageFilterOption,
  isIntakeHubEnabled: boolean,
  isCoverageHubEnabled = false
): PatientPageFilterOption {
  if (isIntakeHubEnabled && intakeTabForFilter(filter)) {
    return PATIENT_PAGE_FILTER_OPTIONS.INTAKE;
  }
  if (!isIntakeHubEnabled && filter === PATIENT_PAGE_FILTER_OPTIONS.INTAKE) {
    return PATIENT_PAGE_FILTER_OPTIONS.MY_PATIENTS;
  }
  if (!isCoverageHubEnabled && filter === PATIENT_PAGE_FILTER_OPTIONS.COVERAGE) {
    return PATIENT_PAGE_FILTER_OPTIONS.MY_PATIENTS;
  }
  return filter;
}
